import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { FiMenu, FiX, FiGlobe, FiChevronDown } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { user, logout } = useAuth();
  const location = useLocation();
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setMobileOpen(false);
  };

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => setMobileOpen(false), [location]);

  const navItems = [
    { path: '/', label: t('nav.home') },
    { path: '/events', label: t('nav.events') },
    { path: '/trainers', label: t('nav.trainers') },
    { path: '/gyms', label: t('nav.gyms') },
    { path: '/about', label: t('nav.about') },
    { path: '/faq', label: t('nav.faq') },
    { path: '/contact', label: t('nav.contact') },
  ];

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-inner">
        <Link to="/" className="navbar-logo">
          <img src="/logo.png" alt="UzSport" style={{ height: 40, width: 'auto' }} />
          <span>UzSport</span>
        </Link>

        <div className={`nav-links ${mobileOpen ? 'mobile-open' : ''}`}>
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
            >
              {item.label}
            </Link>
          ))}
        </div>

        <div className="nav-actions">
          {/* Language Switcher */}
          <div className="lang-switcher">
            <button className="lang-btn">
              <FiGlobe /> {i18n.language.toUpperCase()} <FiChevronDown />
            </button>
            <div className="lang-dropdown">
              <button onClick={() => changeLanguage('uz')}>UZ</button>
              <button onClick={() => changeLanguage('ru')}>RU</button>
              <button onClick={() => changeLanguage('en')}>EN</button>
            </div>
          </div>

          {user ? (
            <>
              <Link to="/admin" className="btn btn-ghost btn-sm">{t('nav.dashboard')}</Link>
              <button onClick={logout} className="btn btn-outline btn-sm">{t('nav.logout')}</button>
            </>
          ) : (
            <Link to="/login" className="btn btn-primary btn-sm">{t('nav.login')}</Link>
          )}
          <button className="mobile-menu-btn" onClick={() => setMobileOpen(!mobileOpen)}>
            {mobileOpen ? <FiX /> : <FiMenu />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
